import { render } from "./Detail-index.vue?vue&type=template&id=46509d29&scoped=true"
import script from "./Detail-index.vue?vue&type=script&lang=js"
export * from "./Detail-index.vue?vue&type=script&lang=js"

import "./Detail-index.vue?vue&type=style&index=0&id=46509d29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46509d29"]])

export default __exports__